import React from "react";
import ServiceForm from "./ServiceForm";

export default function AddService() {
    return <ServiceForm type="Add" />;
}
